module.exports = __webpack_public_path__ + "static/img/1.35e979e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/3/sp/1.png
// module id = p7ap
// module chunks = 0